<template>
  <div>
    <intervention :key="interventionId" :id="interventionId" v-if="isInterventionOpened" />
    <challenging-intervention :key="challengingInterventionId" :id="challengingInterventionId" v-else-if="isChallengingInterventionOpened" />
    <v-row no-gutters justify="center" align="start" v-else>
      <div class="n-container">
        <div class="top-right-round-bg"></div>
        <v-row no-gutters justify="start" align="start">
          <v-expand-x-transition>
            <div style="margin-bottom: 250px;" v-show="areFiltersOpened">
              <div class="side-content-medium ml-6">
                <v-row no-gutters align="center" class="content-header">
                  <v-icon small color="accent" class="mr-2 font-weight-bold">filter_list</v-icon>
                  <div class="font-weight-bold primary--text">Filtres</div>
                  <v-spacer></v-spacer>
                  <v-btn icon color="primary" @click="areFiltersOpened = false">
                    <v-icon small>clear</v-icon>
                  </v-btn>
                </v-row>
                <div style="position: relative;">
                  <div class="bottom-left-round-bg"></div>
                  <img src="@/assets/drawings/interventions.png" class="under-filters-drawing">
                  <n-card class="pt-2 pb-6">
                    <div class="filter-item-title mt-4 px-4 primary--text">
                      Statut
                    </div>
                    <div class="filter-item-content-list px-4">
                      <v-autocomplete
                        :items="statuses"
                        v-model="selectedStatuses"
                        @change="statusFilterChanged"
                        single-line
                        solo
                        multiple
                        clearable
                        chips
                        small-chips
                        label="Tous"
                        hide-details
                        item-text="name"
                        item-value="id"
                        flat
                        class="n-multi-select mr-4"
                        style="width: 100%;"
                        ref="statusSelect"
                      >
                        <template v-slot:item="{ item }">
                          {{ item.name }}
                        </template>
                      </v-autocomplete>
                    </div>
                    <template v-if="canFilterByMaker">
                      <div class="filter-item-title mt-4 px-4 primary--text">
                        Prestataire
                      </div>
                      <div class="filter-item-content-list px-4">
                        <v-autocomplete
                          :items="makers"
                          v-model="maker"
                          single-line
                          solo
                          label="Tous"
                          hide-details
                          item-text="name"
                          item-value="id"
                          clearable
                          flat
                          height="36px"
                          style="width: 100%;"
                          class="n-select mr-4"
                        ></v-autocomplete>
                      </div>
                    </template>
                    <template v-else-if="isMaker && isMakerUser">
                      <div class="filter-item-title mt-4 px-4 primary--text">
                        Client
                      </div>
                      <div class="filter-item-content-list px-4">
                        <v-autocomplete
                          :items="clients"
                          v-model="client"
                          single-line
                          solo
                          label="Tous"
                          hide-details
                          item-text="name"
                          item-value="id"
                          clearable
                          flat
                          height="36px"
                          style="width: 100%;"
                          class="n-select mr-4"
                        ></v-autocomplete>
                      </div>
                    </template>
                    <template v-if="client">
                      <div class="filter-item-title mt-4 px-4 primary--text">
                        Site
                      </div>
                      <div class="filter-item-content-list px-4">
                        <v-autocomplete
                          :items="sites"
                          v-model="site"
                          single-line
                          solo
                          label="Tous"
                          hide-details
                          item-text="$label"
                          item-value="id"
                          clearable
                          flat
                          height="36px"
                          style="width: 100%;"
                          class="n-select mr-4"
                        ></v-autocomplete>
                      </div>
                    </template>
                    <template v-if="maker">
                      <div class="filter-item-title mt-4 px-4 primary--text">
                        Domaine
                      </div>
                      <div class="filter-item-content-list px-4">
                        <v-autocomplete
                          :items="domains"
                          v-model="domain"
                          single-line
                          solo
                          label="Tous"
                          hide-details
                          item-text="name"
                          item-value="id"
                          clearable
                          flat
                          height="36px"
                          style="width: 100%;"
                          class="n-select mr-4"
                        ></v-autocomplete>
                      </div>
                      <div class="filter-item-title mt-4 px-4 primary--text">
                        Priorité
                      </div>
                      <div class="filter-item-content-list px-4">
                        <v-autocomplete
                          :items="priorities"
                          v-model="priority"
                          single-line
                          solo
                          label="Toutes"
                          hide-details
                          item-text="name"
                          item-value="id"
                          clearable
                          flat
                          height="36px"
                          style="width: 100%;"
                          class="n-select mr-4"
                        ></v-autocomplete>
                      </div>
                      <template v-if="isMakerUser">
                        <div class="filter-item-title mt-4 px-4 primary--text">
                          Tags
                        </div>
                        <div class="filter-item-content-list px-4">
                          <v-autocomplete
                            :items="dbTags"
                            v-model="tags"
                            single-line
                            solo
                            label="Tous"
                            hide-details
                            item-text="label"
                            item-value="id"
                            clearable
                            flat
                            multiple
                            chips
                            deletable-chips
                            small-chips
                            style="width: 100%;"
                            class="n-multi-select mr-4"
                          >
                            <template v-slot:item="{ item: tag }">
                              <v-list-item-avatar size="20" style="margin-top: 4px;">
                                <v-avatar :color="tag.color"></v-avatar>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                {{ tag.label }}
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </div>
                      </template>
                    </template>
                    <template v-if="client">
                      <div class="filter-item-title mt-4 px-4 primary--text">
                        Équipement
                      </div>
                      <div class="filter-item-content-list px-4">
                        <v-autocomplete
                          :items="equipments"
                          v-model="equipment"
                          :filter="filterEquipments"
                          single-line
                          solo
                          label="Tous"
                          hide-details
                          item-text="label"
                          item-value="id"
                          clearable
                          flat
                          height="36px"
                          style="width: 100%;"
                          class="n-select mr-4"
                        >
                          <template v-slot:item="{ item: equipment, on, attrs }">
                            <v-list-item v-on="on" v-bind="attrs">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <template v-if="equipment.number">
                                    {{ equipment.number }}
                                    <span class="px-1">-</span>
                                  </template>
                                  {{ equipment.label }}
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="equipment.model || equipment.brand">
                                  <template v-if="equipment.brand">
                                    {{ equipment.brand }}
                                  </template>
                                  <template v-if="equipment.model && equipment.brand">
                                    <span class="px-1">-</span>
                                  </template>
                                  <template v-if="equipment.model">
                                    {{ equipment.model }}
                                  </template>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                  <template v-if="equipment.serialNumber">
                                    {{ equipment.serialNumber }}
                                  </template>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </div>
                    </template>
                    <template v-if="isAggregator && isAggregatorUser">
                      <div class="filter-item-title mt-4 px-4 primary--text">
                        Tags
                      </div>
                      <div class="filter-item-content-list px-4">
                        <v-autocomplete
                          :items="dbTags"
                          v-model="tags"
                          single-line
                          solo
                          label="Tous"
                          hide-details
                          item-text="label"
                          item-value="id"
                          clearable
                          flat
                          multiple
                          chips
                          deletable-chips
                          small-chips
                          style="width: 100%;"
                          class="n-multi-select mr-4"
                        >
                          <template v-slot:item="{ item: tag }">
                            <v-list-item-avatar size="20" style="margin-top: 4px;">
                              <v-avatar :color="tag.color"></v-avatar>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              {{ tag.label }}
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </div>
                    </template>
                  </n-card>
                </div>
              </div>
            </div>
          </v-expand-x-transition>
          <v-col align="center" class="pa-0 mx-6">
            <header-controls
              :areFiltersOpened="areFiltersOpened"
              @filters:open="areFiltersOpened = true"
              @pager:change="fetchInterventions"
              @refresh="forceFetchInterventions"
            />
            <v-row no-gutters justify="center" align="center" v-if="isFetchingList">
              <div style="margin-top: 20%; width: 250px;">
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
            </v-row>
            <intervention-table-layout
              v-else-if="currentLayout === `table`"
              @pager:change="fetchInterventions"
            />
            <div class="page-main-content" v-else>
              <template v-if="interventions.length > 0 || challengingInterventions.length > 0">
                <template v-for="(intervention, i) in challengingInterventions">
                  <div :key="`challenging-interventions-${i}`" class="mb-3" @click="goToChallengingIntervention(intervention.id)">
                    <intervention-card :value="intervention" :clickable="true" is-challenging></intervention-card>
                  </div>
                </template>
                <template v-for="(intervention, i) in interventions">
                  <div :key="`interventions-${i}`" class="mb-4" @click="goToIntervention(intervention.id)">
                    <intervention-card :value="intervention" :clickable="true"></intervention-card>
                  </div>
                </template>
                <pager @change="fetchInterventions()" class="mt-6" />
              </template>
              <div v-else>
                <v-row no-gutters justify="center" align="center" style="margin-top: 20%; font-weight: 500;">
                  Aucune intervention à afficher
                </v-row>
                <v-row no-gutters justify="center" align="center" class="pt-6">
                  <v-btn
                    class="n-small-btn n-primary-btn"
                    :disabled="!$canWrite" @click.prevent="$canWrite && goToNewIntervention()"
                    v-if="canCreateIntervention && rights.interventions"
                  >
                    En créer une nouvelle ?
                  </v-btn>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapMutations, mapState } from 'vuex';
import InterventionTableLayout from '@/views/Interventions/TableLayout.vue';
import InterventionCard from '@/components/Interventions/Card.vue';
import Intervention from '@/components/Interventions/Intervention.vue';
import ChallengingIntervention from '@/components/Interventions/ChallengingIntervention.vue';
import Pager from '@/components/Interventions/Pager.vue';
import HeaderControls from '@/components/Interventions/HeaderControls.vue';

export default {
  name: `Tickets`,
  data: () => ({
    isReadyToFetchInterventions: false,
    readyToFetchInterventionsTimeout: null,
    // areFiltersOpened: true,
    interventionId: null,
    challengingInterventionId: null,
    isListHasBeenFetchedOnce: false,
    isFetchingList: false,
    selectedStatuses: [],
  }),
  computed: {
    ...mapState(`model/status`, {
      statuses(state) {
        return [
          ...this.shortcutFilters,
          ...state.statuses,
        ];
      },
    }),
    ...mapState(`model/maker`, [
      `makers`,
    ]),
    ...mapState(`model/client`, [
      `company`,
      `rights`,
      `clients`,
      `isAggregator`,
      `isMaker`,
      `isSimpleMaker`,
    ]),
    ...mapState(`model/client`, {
      sites: state => state.sites.map(site => {
        const $refLabel = site.ref && site.ref.length ? ` (Ref: ${site.ref})` : ``;
        return {
          ...site,
          $label: `${site.name}${$refLabel}`,
        };
      }),
    }),
    ...mapState(`model/user`, [
      `me`,
      `isMakerUser`,
      `isAggregatorUser`,
    ]),
    ...mapState(`ui/interventions`, {
      interventions: `list`,
      challengingInterventions: `challengingList`,
      domains: state => _.sortBy(state.domains || [], domain => _.toLower(domain.name)),
    }),
    ...mapState(`ui/interventions`, [
      `shortcutFilters`,
      // `sorts`,
      `dbTags`,
      `priorities`,
      `dbEquipments`,
    ]),
    ...mapGetters(`ui/interventions`, [
      `currentLayout`,
      `currentSort`,
      `currentNbItemsPerPage`,
    ]),
    equipments() {
      return this.dbEquipments.map(equipment => ({
        ...equipment,
        $searchString: _.toLower(`
          ${equipment.number || ``} ${equipment.label || ``} ${equipment.brand || ``} ${equipment.model || ``} ${equipment.serialNumber || ``}
        `).replace(/ +/g, ` `),
      }));
    },
    hasStatusFilter() {
      return this.isStatusFilterById || !_.isNull(this.shortcutFilter);
    },
    isStatusFilterById() {
      return !_.isUndefined(this.status) && !_.isNull(this.status);
    },
    shortcutFilter: {
      get() { return this.$store.state[`ui/interventions`].shortcutFilter; },
      set(shortcutFilter) { this.$store.commit(`ui/interventions/SET_SHORTCUT_FILTER`, shortcutFilter); },
    },
    areFiltersOpened: {
      get() { return this.$store.getters[`ui/interventions/currentFiltersOpened`]; },
      set(areFiltersOpened) { this.$store.commit(`ui/interventions/SET_FILTERS_OPENED`, areFiltersOpened); },
    },
    status: {
      get() { return this.$store.state[`ui/interventions`].status; },
      set(status) { this.$store.commit(`ui/interventions/SET_STATUS`, status); },
    },
    maker: {
      get() { return this.$store.state[`ui/interventions`].maker; },
      set(maker) { this.$store.commit(`ui/interventions/SET_MAKER`, maker); },
    },
    client: {
      get() { return this.$store.state[`ui/interventions`].client; },
      set(client) { this.$store.commit(`ui/interventions/SET_CLIENT`, client); },
    },
    site: {
      get() { return this.$store.state[`ui/interventions`].site; },
      set(site) { this.$store.commit(`ui/interventions/SET_SITE`, site); },
    },
    domain: {
      get() { return this.$store.state[`ui/interventions`].domain; },
      set(domain) { this.$store.commit(`ui/interventions/SET_DOMAIN`, domain); },
    },
    priority: {
      get() { return this.$store.state[`ui/interventions`].priority; },
      set(priority) { this.$store.commit(`ui/interventions/SET_PRIORITY`, priority); },
    },
    tags: {
      get() { return this.$store.state[`ui/interventions`].tags; },
      set(tags) { this.$store.commit(`ui/interventions/SET_TAGS`, tags); },
    },
    equipment: {
      get() { return this.$store.state[`ui/interventions`].equipment; },
      set(equipment) { this.$store.commit(`ui/interventions/SET_EQUIPMENT`, equipment); },
    },
    canCreateIntervention() {
      let can = Boolean(this.me.clientAdmin);

      if (!can) {
        (this.me.rights || []).forEach(userRight => {
          const canOnMaker = userRight.right.id === 3;
          can = can || canOnMaker;
        });
      }

      return can;
    },
    isInterventionOpened() {
      return this.interventionId !== null;
    },
    isChallengingInterventionOpened() {
      return this.challengingInterventionId !== null;
    },
    canFilterByMaker() {
      return this.isAggregator && (this.isAggregatorUser || this.me.isIndeego);
    },
  },
  methods: {
    ...mapMutations(`ui/interventions`, {
      setInterventions: `SET_LIST`,
    }),
    statusFilterChanged() {
      let candidates = [];
      this.selectedStatuses.forEach((status, i) => {
        if (i === (this.selectedStatuses.length - 1) && !_.isInteger(status)) {
          candidates = [status];
          this.$refs.statusSelect.blur();
        } else if (_.isInteger(status)) {
          candidates.push(status);
        }
      });
      document.querySelectorAll(`.v-autocomplete__content .v-list-item--highlighted`)
        .forEach(el => {
          el.classList.remove(`v-list-item--highlighted`);
        });
      this.status = candidates.join(`,`);
      this.selectedStatuses = candidates;
    },
    readyToFetchInterventions(isReadyToFetchInterventions) {
      return new Promise(resolve => {
        clearTimeout(this.readyToFetchInterventionsTimeout);
        this.readyToFetchInterventionsTimeout = setTimeout(() => {
          this.isReadyToFetchInterventions = isReadyToFetchInterventions;
          resolve();
        }, 100);
      });
    },
    goToNewIntervention() {
      if (this.$route.name === `newTicket`) {
        this.$store.dispatch(`ui/newIntervention/changeReloadKey`);
      } else {
        this.$router.push({ name: `newTicket` });
      }
    },
    setStatusFilterShortcut(shortcutFilter) {
      this.status = null;
      this.shortcutFilter = shortcutFilter;
    },
    clearStatusFilter() {
      this.shortcutFilter = null;
      this.status = null;
    },
    goToChallengingIntervention(id) {
      if (this.challengingInterventionId && this.challengingInterventionId === id) {
        return;
      }

      this.$router.push({
        name: `InterventionsChallengingIntervention`,
        params: {
          challengingInterventionId: id,
        },
      });
    },
    goToIntervention(id) {
      if (this.interventionId && this.interventionId === id) {
        return;
      }

      this.$router.push({
        name: `InterventionsIntervention`,
        params: {
          interventionId: id,
        },
      });
    },
    async forceFetchInterventions() {
      this.isFetchingList = true;
      await this.$store.dispatch(`ui/interventions/forceFetchList`);
      this.isFetchingList = false;
      this.isListHasBeenFetchedOnce = true;
    },
    async fetchInterventions(isInitPager = false) {
      setTimeout(async () => {
        if (!this.isReadyToFetchInterventions) { return; }
        this.isFetchingList = true;
        if (isInitPager) {
          this.$store.commit(`ui/interventions/SET_PAGE`, 1);
        }
        await this.$store.dispatch(`ui/interventions/fetchList`);
        this.isFetchingList = false;
        this.isListHasBeenFetchedOnce = true;
      }, 1);
    },
    adjustInterventionsNbItems() {
      this.setInterventions(this.interventions.slice(0, this.currentNbItemsPerPage));
    },
    setInterventionIdFromRoute() {
      const params = this.$route.params || {};
      this.interventionId = params.interventionId || null;
    },
    setChallengingInterventionIdFromRoute() {
      const params = this.$route.params || {};
      this.challengingInterventionId = params.challengingInterventionId || null;
    },
    async fetchUiDatas() {
      const promises = [
        this.fetchInterventions(),
      ];
      if (this.isAggregator) {
        promises.push(this.$store.dispatch(`model/client/fetchSites`, this.client));
        promises.push(this.$store.dispatch(`ui/interventions/fetchClientTags`, this.client));
      } else if (this.isMakerUser) {
        promises.push(this.$store.dispatch(`model/client/fetchClients`, this.maker));
      }
      // if (!this.isAggregatorUser) {
      if (this.isMaker) {
        promises.push(
          this.$store.dispatch(`model/priority/fetchMakerPriorities`),
          this.$store.dispatch(`model/domain/fetchMakerDomains`),
          this.$store.dispatch(`model/status/fetchStatuses`),
          this.$store.dispatch(`ui/interventions/fetchDbTags`)
        );
      } else {
        promises.push(this.$store.dispatch(`model/maker/fetchMakers`));
      }
      await Promise.all(promises);
    },
    filterEquipments(item, queryText) {
      const searchString = _.toLower(queryText);
      return item.$searchString.indexOf(searchString) !== -1;
    },
  },
  async beforeMount() {
    this.isReadyToFetchInterventions = false;
    if (this.isAggregator) {
      this.$store.commit(`ui/interventions/SET_CLIENT`, this.company.id);
    } else if (!this.me.client.isRoot) {
      this.$store.commit(`ui/interventions/SET_CLIENT`, this.me.client.id);
    }
    if (this.isMaker) {
      this.$store.commit(`ui/interventions/SET_MAKER`, this.company.id);
    }
    this.setInterventionIdFromRoute();
    this.setChallengingInterventionIdFromRoute();
    if (!this.interventionId) {
      this.setInterventions([]);
    }
    if (!this.status) {
      const defaultStatusIndex = this.company.slug === `ices` ? 1 : 3;
      this.status = this.statuses[defaultStatusIndex].id;
    }
    await this.readyToFetchInterventions(true);
    if (!this.interventionId) {
      this.fetchUiDatas();
    }
  },
  components: {
    InterventionTableLayout,
    InterventionCard,
    Intervention,
    ChallengingIntervention,
    Pager,
    HeaderControls,
  },
  watch: {
    '$route.path': function watchRoutePath() {
      this.setInterventionIdFromRoute();
      this.setChallengingInterventionIdFromRoute();
    },
    interventionId(interventionId) {
      if (!interventionId) {
        this.fetchUiDatas();
      }
    },
    // currentLayout() { this.fetchInterventions(); },
    currentSort() { this.fetchInterventions(true); },
    currentNbItemsPerPage(currentNbItemsPerPage, oldNbItemsPerPage) {
      if (currentNbItemsPerPage > oldNbItemsPerPage) {
        this.fetchInterventions(true);
      } else {
        this.adjustInterventionsNbItems();
      }
    },
    shortcutFilter() { this.fetchInterventions(true); },
    status() { this.fetchInterventions(true); },
    maker() {
      this.domain = null;
      this.priority = null;
      this.$store.dispatch(`ui/interventions/fetchPriorities`);
      this.$store.dispatch(`ui/interventions/fetchDomains`);
      this.fetchInterventions(true);
    },
    client() {
      this.$store.dispatch(`ui/interventions/fetchEquipments`);
      if (this.client) {
        this.$store.dispatch(`model/client/fetchSites`, this.client);
      }
      this.site = null;
      this.fetchInterventions(true);
    },
    site() {
      this.$store.dispatch(`ui/interventions/fetchEquipments`);
      this.fetchInterventions(true);
    },
    domain() { this.fetchInterventions(true); },
    priority() { this.fetchInterventions(true); },
    tags() { this.fetchInterventions(true); },
    equipment() { this.fetchInterventions(true); },
  },
};
</script>

<style lang="scss">

.filter-item-title {
  font-weight: 500;
}

.filter-item-content-list {
  padding-top: 6px;
  & > a {
    padding: 6px 4px;
    display: block;
    color: #333 !important;
    font-size: 0.9rem;
    &:hover {
      background-color: #EEE;
    }
    &.selected {
      background-color: #2226ca;
      font-weight: 500;
      color: #FFF !important;
    }
  }
}

.interventions-sort-select {
  border: 1px solid rgba(19, 26, 154, 0.1) !important;
  -webkit-box-shadow: 3px 3px 10px 1px rgba(19, 26, 154, 0.1);
  -moz-box-shadow:    3px 3px 10px 1px rgba(19, 26, 154, 0.1);
  box-shadow:         3px 3px 10px 1px rgba(19, 26, 154, 0.1);
  max-height: 32px !important;
  max-width: 425px;
  .v-input__prepend-inner {
    .v-icon {
      font-size: 1.2rem;
      font-weight: 700;
      color: $primaryColor;
    }
  }
  .v-input__append-inner {
    .v-icon {
      font-size: 1.2rem;
      font-weight: 700;
      color: $primaryColor;
    }
  }
  .v-input__slot {
    margin-top: -3px;
  }
  .v-select__slot {
    padding-right: 28px;
    .v-select__selection {
      // margin-top: 0px !important;
      color: $primaryColor;
      max-width: 100% !important;;
    }
  }
  input[type=text] {
    width: 1px !important;
    flex: none;
  }
}

@media only screen and (max-width: 1260px) {
  .interventions-sort-select {
    max-width: 320px;
  }
}

.top-right-round-bg {
  position: absolute;
  top: -200px;
  right: -200px;
  width: 520px;
  height: 520px;
  background: #F3F3FA;
  border-radius: 50%;
  z-index: 5;
}

.bottom-left-round-bg {
  position: absolute;
  bottom: -260px;
  left: -120px;
  width: 380px;
  height: 380px;
  background: #F3F3FA;
  border-radius: 50%;
  z-index: 5;
}

.under-filters-drawing {
  position: absolute;
  bottom: -260px;
  left: 30px;
  z-index: 5;
  width: 220px;
}

</style>
